import services from '../components/services/services.js';
// import testimonials from '../components/testimonials/testimonials.js';
import locations from '../components/location/location.js';


export default {
    name: 'information',
    label: 'Äriinformatsioon',
    i18n: {
        structure: 'single_file',
    },
    files: [services, locations],
};